<span (click)="open()"><mat-icon>visibility</mat-icon> {{attachment.name}}</span>